import { styled, Switch as SwitchMui } from '@mui/material';
export var Switch = styled(SwitchMui)(function (_a) {
    var theme = _a.theme;
    return ({
        width: 34,
        height: 20,
        padding: 0,
        '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: 2,
            transitionDuration: '300ms',
            '&.Mui-checked': {
                transform: 'translateX(14px)',
                color: '#fff',
                '& + .MuiSwitch-track': {
                    backgroundColor: '#9FC642',
                    opacity: 1,
                    border: 0,
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                    opacity: 0.5,
                },
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
                color: '#9FC642',
                border: '4px solid #fff',
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.7,
            },
        },
        '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 16,
            height: 16,
        },
        '& .MuiSwitch-track': {
            borderRadius: 20 / 2,
            backgroundColor: '#E0E0E0',
            opacity: 1,
            transition: theme.transitions.create(['background-color'], {
                duration: 500,
            }),
        },
    });
});
